import notecontext from "../Context/notes/Notecontext";
import { useContext, useEffect, useRef, useState } from "react";
import Notesitem from "./Notesitem";
import Alert from "./Alert";
// Initialization for ES Users
import { Modal, Ripple, initTE } from "tw-elements";
import Loader2 from "./Loader2";
import "../Css/Front.css"
export default function Notes() {
  initTE({ Modal, Ripple });
  const notes = useContext(notecontext);
  const [load, setload] = useState(false);
  const { state, getallNotes, editnote, deletenote } = notes;
  const [alert, setalert] = useState({ msg: null, type: "" });
  const [note, setnote] = useState({
    id: "",
    etitle: "",
    edescription: "",
    etag: "",
  });
  const desired_output = (employees_details) => {
    let unique_values = employees_details
      .map((item) => item.tag)
      .filter(
        (value, index, current_value) => current_value.indexOf(value) === index
      );
    return unique_values;
  };
  const unique = desired_output(state);
  const filtering_data = [];
  useEffect(() => {
    setload(true);
    getallNotes();
    setload(false);
    //eslint--disable-next-line
  }, []);
  let [filtered, setfiltered] = useState();
  useEffect(() => {
    setfiltered(state?.filter((data) => data?._id?.length > 1));
  }, [state]);

  const updatenote = (currentnote) => {
    setnote({
      id: currentnote._id,
      etitle: currentnote.title,
      edescription: currentnote.description,
      etag: currentnote.tag,
    });

    ref.current.click();
  };
  const deleteit = (id) => {
    deletenote(id);
    setalert({ msg: "Task Deleted Successfully!", type: "success" });
    setTimeout(() => {
      setalert({ msg: null, type: "" });
    }, 3000);
  };
  const ref = useRef("");
  const refclo = useRef("");
  const onchange = (e) => {
    setnote({ ...note, [e.target.name]: e.target.value });
  };
  const savechnages = (e) => {
    console.log(`Your Note has been changed details are`, note);
    editnote(note.id, note.etitle, note.edescription, note.etag);
    setalert({ msg: "Task Updated Successfully!", type: "success" });
    setTimeout(() => {
      setalert({ msg: null, type: "" });
    }, 3000);
    refclo.current.click();
  };
  const onchanges = (e) => {
    if (e.target.checked) {
      filtering_data.push(e.target.value);
      console.log(filtering_data);
      filtering_data.map((data) => {
        
        setfiltered(state?.filter((news) => news?.tag == data));
      });
    } else {
      setfiltered(state?.filter((news) => news?._id?.length > 1));
    }
  };
  return (
    <>
      <div>
        <Alert msg={alert.msg} type={alert.type} />

        <div class="btn-group">
          <button
            type="button"
            class="btn bg-theme dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Filter Task by tags
          </button>
          <ul class="dropdown-menu">
            <div className=" w-75 px-3">
              {unique.map((data, index) => {
                return (
                  <div className="form-check d-flex my-2">
                    <div class="checkbox-wrapper">
                      <input
                        id={index}
                        type="checkbox"
                        key={index}
                        onChange={onchanges}
                        class="form-check-input"
                        value={data}
                      />
                      <label class="form-check-label" htmlFor={index}>
                        <div class="tick_mark"></div>
                        
                      </label>
                     
                    </div>
                    <label class="form-check-label px-2 bold" htmlFor={index}>
                        
                        {data}
                      </label>

                    {/* <input
                      key={index}
                      onChange={onchanges}
                      class="form-check-input"
                      type="checkbox"
                      value={data}
                      id={index}
                      
                    />
                    <label class="form-check-label" htmlFor={index}>
                      {data}
                    </label> */}
                  </div>
                );
              })}
            </div>
          </ul>
        </div>
        {/* <button
          type="button d-none"
          ref={ref}
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
        ></button>  */}
        <div class="space-y-2 d-none">
          <button
            type="button"
            class="inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
            data-te-toggle="modal"
            data-te-target="#exampleModalCenter"
            data-te-ripple-init
            data-te-ripple-color="light"
            ref={ref}
          ></button>
        </div>

        {/* <div
          className="modal fade "
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Edit Notes
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label htmlhtmlFor="etitle" className="form-label">
                      Title
                    </label>
                    <input
                      type="text"
                      onChange={onchange}
                      className="form-control"
                      value={note.etitle}
                      name="etitle"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlhtmlFor="edescription" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      onChange={onchange}
                      value={note.edescription}
                      name="edescription"
                      id="exampleFormControlTextarea1"
                      rows="3"
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label htmlhtmlFor="etag" className="form-label">
                      Tag
                    </label>
                    <input
                      type="text"
                      onChange={onchange}
                      className="form-control"
                      name="etag"
                      value={note.etag}
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  ref={refclo}
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  onClick={savechnages}
                  className="btn btn-primary"
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div> */}
        {load ? (
          <Loader2 />
        ) : (
          <div className=" row ">
            {filtered?.map((data, index) => {
              return (
                <Notesitem
                  key={data?._id}
                  item_id={data?._id}
                  title={data?.title}
                  description={data?.description}
                  tag={data?.tag}
                  updatenote={updatenote}
                  note={data}
                  deletenote={deleteit}
                />
              );
            })}
          </div>
        )}
      </div>
      <div
        data-te-modal-init
        class="fixed  left-0 top-0 z-3 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="exampleModalCenter"
        tabindex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-modal="true"
        role="dialog"
      >
        <div
          data-te-modal-dialog-ref
          class="mt-24 justify-center  pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:min-h-[calc(100%-3.5rem)] min-[576px]:max-w-[500px]"
        >
          <div class="w-75  pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600">
            <div class="flex flex-shrink-0 items-center justify-between rounded-t-md border-b-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50">
              <h5
                class="text-xl font-medium leading-normal text-neutral-800 dark:text-neutral-200"
                id="exampleModalCenterTitle"
              >
                Modal title
              </h5>
              <button
                type="button"
                class="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                data-te-modal-dismiss
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="h-6 w-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div class="relative p-4">
              <form>
                <div className="mb-3">
                  <label htmlhtmlFor="etitle" className="form-label">
                    Title
                  </label>
                  <input
                    type="text"
                    onChange={onchange}
                    className="form-control"
                    value={note.etitle}
                    name="etitle"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div className="mb-3">
                  <label htmlhtmlFor="edescription" className="form-label">
                    Description
                  </label>
                  <textarea
                    className="form-control"
                    onChange={onchange}
                    value={note.edescription}
                    name="edescription"
                    id="exampleFormControlTextarea1"
                    rows="3"
                  ></textarea>
                </div>
                <div className="mb-3">
                  <label htmlhtmlFor="etag" className="form-label">
                    Tag
                  </label>
                  <input
                    type="text"
                    onChange={onchange}
                    className="form-control"
                    name="etag"
                    value={note.etag}
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                  />
                </div>
              </form>
            </div>

            <div class="flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50">
              <button
                type="button"
                class="inline-block rounded bg-primary-100 px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-primary-700 transition duration-150 ease-in-out hover:bg-primary-accent-100 focus:bg-primary-accent-100 focus:outline-none focus:ring-0 active:bg-primary-accent-200"
                data-te-modal-dismiss
                data-te-ripple-init
                data-te-ripple-color="light"
                ref={refclo}
              >
                Close
              </button>
              <button
                type="button"
                class="ml-1 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                data-te-ripple-init
                data-te-ripple-color="light"
                onClick={savechnages}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
